import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { WireframeSphere } from './WireframeSphere';
import { CornerBrackets } from './CornerBrackets';
import { CyberButton } from './CyberButton';
export function FeatureSection() {
  const {
    t
  } = useLanguage();
  const handleScrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-black/90 relative overflow-hidden" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-127">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-128">
            <div className="flex items-center gap-2 mb-4" data-id="element-129">
              <span className="text-magenta font-cyber text-sm font-bold" data-id="element-130">
                //
              </span>
              <span className="text-xs font-bold text-magenta uppercase tracking-[0.2em]" data-id="element-131">
                {t.feature.badge}
              </span>
            </div>

            <h2 className="font-cyber text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-132">
              {t.feature.title.split(' ').slice(0, 2).join(' ')}
              <br data-id="element-133" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan to-magenta drop-shadow-[0_0_10px_rgba(0,212,255,0.3)]" data-id="element-134">
                {t.feature.title.split(' ').slice(2).join(' ')}
              </span>
            </h2>

            <p className="subtitle-text mb-8" data-id="element-135">{t.feature.subtitle}</p>

            <ul className="space-y-4 mb-10" data-id="element-136">
              {t.feature.features.map((item, i) => <li key={i} className="flex items-center gap-4 text-sm text-gray-300 group" data-id="element-137">
                  <div className="relative flex h-2 w-2" data-id="element-138">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan opacity-75 group-hover:opacity-100" data-id="element-139"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan" data-id="element-140"></span>
                  </div>
                  <span className="group-hover:text-white transition-colors" data-id="element-141">
                    {item}
                  </span>
                </li>)}
            </ul>

            <CyberButton variant="secondary" onClick={handleScrollToServices} data-id="element-142">
              {t.hero.ctaSecondary.toUpperCase()}
            </CyberButton>
          </motion.div>

          {/* Right Content - Sphere */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-143">
            <div className="relative bg-black/40 backdrop-blur-sm p-1" data-id="element-144">
              <div className="absolute inset-0 border border-white/10" style={{
              clipPath: 'polygon(20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%, 0 20px)'
            }} data-id="element-145" />
              <div className="relative p-6" style={{
              clipPath: 'polygon(20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%, 0 20px)'
            }} data-id="element-146">
                <div className="flex justify-between items-center mb-4 border-b border-white/10 pb-2" data-id="element-147">
                  <div className="flex gap-2" data-id="element-148">
                    <div className="w-2 h-2 bg-magenta rounded-full animate-pulse" data-id="element-149" />
                    <span className="text-[10px] font-cyber text-gray-500 tracking-widest" data-id="element-150">
                      {t.feature.aiStatus}
                    </span>
                  </div>
                  <div className="flex gap-1" data-id="element-151">
                    <div className="w-1 h-1 bg-white/20" data-id="element-152" />
                  </div>
                </div>
                <WireframeSphere data-id="element-153" />
                <CornerBrackets color="magenta" className="opacity-50" data-id="element-154" />
              </div>
            </div>
            <div className="absolute -inset-4 bg-magenta/5 blur-3xl -z-10 rounded-full opacity-50" data-id="element-155" />
          </motion.div>
        </div>
      </div>
    </section>;
}